module.exports = __webpack_public_path__ + "assets/img/Type E (35).2a09d38b.jpg";